export const DYNAMIC_FRAME_REQUEST_START_EVENT = 'dynamic-frame:request-start'
export const DYNAMIC_FRAME_REQUEST_END_EVENT = 'dynamic-frame:request-end'

let requestSequence = 0

export function nextDynamicFrameRequestId() {
  requestSequence += 1
  return `dynamic-frame-request-${requestSequence}`
}

export function dispatchDynamicFrameRequestEvent(trigger, eventName, detail) {
  if (!trigger?.dispatchEvent) return

  trigger.dispatchEvent(new CustomEvent(eventName, { bubbles: true, detail }))
}

export async function withDynamicFrameRequestLifecycle({ trigger, frameKey, request }) {
  const requestId = nextDynamicFrameRequestId()
  let status = 'failed'

  dispatchDynamicFrameRequestEvent(trigger, DYNAMIC_FRAME_REQUEST_START_EVENT, { requestId, frameKey })

  try {
    const result = await request()
    status = 'succeeded'
    return result
  } catch (error) {
    status = error?.name === 'AbortError' ? 'aborted' : 'failed'
    throw error
  } finally {
    dispatchDynamicFrameRequestEvent(trigger, DYNAMIC_FRAME_REQUEST_END_EVENT, { requestId, frameKey, status })
  }
}
